// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__heBVS","row":"Node_row__2Lqk8","label":"Node_label__CvjyY","footer":"Node_footer__2xQpu"};